import Vue from 'vue'

export const PARISH_CLEAR = 'PARISH_CLEAR'
export const PARISH_SET_LIST = 'm_PARISH_SET_LIST'
export const PARISH_SET_CURRENT = 'm_PARISH_SET_CURRENT'
export const PARISH_SET_PARISH = 'm_PARISH_SET_PARISH'
export const PARISH_SET_BLOCK_IMAGE = 'PARISH_SET_BLOCK_IMAGE'
export const PARISH_SET_BLOCK_TITLE = 'PARISH_SET_BLOCK_TITLE'
export const PARISH_SET_PARISHIONERS = 'm_PARISH_SET_PARISHIONERS'
export const PARISH_TOGGLE_PARISHIONERS_DETAILS = 'm_PARISH_TOGGLE_PARISHIONERS_DETAILS'
export const PARISH_SET_DONATION_TYPES = 'PARISH_SET_DONATION_TYPES'
export const PARISH_SET_DONATION_TYPE = 'PARISH_SET_DONATION_TYPE'
export const PARISH_DEL_DONATION_TYPE = 'PARISH_DEL_DONATION_TYPE'
export const PARISH_SET_DONATIONS = 'PARISH_SET_DONATIONS'
export const PARISH_ADD_DONATION = 'PARISH_ADD_DONATION'
export const PARISH_SET_ALL_DONATIONS = 'PARISH_SET_ALL_DONATIONS'
export const PARISH_SET_DEFAULT_CURRENCY = 'PARISH_SET_DEFAULT_CURRENCY'
export const PARISH_SET_AVAILABLE_CURRENCIES = 'PARISH_SET_AVAILABLE_CURRENCIES'

export default {
  [PARISH_CLEAR]: (state) => {
    state.parishes = {}
    state.parishioners = {}
    state.donationTypes = {}
    state.donations = {}
    state.allDonations = {}
    state.current = null
  },
  [PARISH_SET_LIST]: (state, parishes) => {
    state.parishes = parishes
  },
  [PARISH_SET_CURRENT]: (state, parishId) => {
    state.current = parishId ? state.parishes[parishId] : null
    sessionStorage.setItem('active-parish', parishId)
  },
  [PARISH_SET_PARISH]: (state, parish) => {
    Vue.set(state.parishes, parish.id, parish)
  },
  [PARISH_SET_BLOCK_TITLE]: (state, { parish, block, title }) => {
    state.parishes[parish.id].titles[block] = title
  },
  [PARISH_SET_BLOCK_IMAGE]: (state, { parish, block, image }) => {
    state.parishes[parish.id].images[block] = image
  },
  [PARISH_SET_PARISHIONERS]: (state, { parish, parishioners }) => {
    Vue.set(state.parishioners, parish.id, parishioners)
  },
  [PARISH_TOGGLE_PARISHIONERS_DETAILS]: (state, parishioner) => {
    Object.values(state.parishioners[state.current.id]).map(p => {
      if (p.id === parishioner.id) {
        return
      }
      Vue.set(p, '_showDetails', false)
    })
    Vue.set(parishioner, '_showDetails', !parishioner._showDetails)
  },
  [PARISH_SET_DONATION_TYPES] (state, { parish, donationTypes }) {
    Vue.set(state.donationTypes, parish.id, {})
    Object.keys(donationTypes).forEach(id => {
      Vue.set(state.donationTypes[parish.id], id, donationTypes[id])
    })
  },
  [PARISH_SET_DONATION_TYPE] (state, { parish, donationType }) {
    if (!state.donationTypes[parish.id]) {
      Vue.set(state.donationTypes, parish.id, {})
    }
    Vue.set(state.donationTypes[parish.id], donationType.id, donationType)
  },
  [PARISH_DEL_DONATION_TYPE] (state, { parish, donationType }) {
    if (!state.donationTypes[parish.id]) {
      Vue.set(state.donationTypes, parish.id, {})
    }
    Vue.delete(state.donationTypes[parish.id], donationType.id)
  },
  [PARISH_SET_DONATIONS] (state, { donationType, donations }) {
    if (!state.donations[donationType.id]) {
      Vue.set(state.donations, donationType.id, {})
    }
    Object.keys(donations).forEach(id => {
      Vue.set(state.donations[donationType.id], id, donations[id])
    })
  },
  [PARISH_SET_ALL_DONATIONS] (state, donations) {
    state.allDonations = donations
  },
  [PARISH_ADD_DONATION] (state, { donationType, donation }) {
    if (!state.donations[donationType.id]) {
      Vue.set(state.donations, donationType.id, {})
    }
    Vue.set(state.donations[donationType.id], donation.id, donation)
  },
  [PARISH_SET_DEFAULT_CURRENCY] (state, { parish, currency }) {
    Vue.set(state.parishes[parish.id], 'currency', currency)
  },
  [PARISH_SET_AVAILABLE_CURRENCIES] (state, { parish, currencies }) {
    Vue.set(state.parishes[parish.id], 'currencies', currencies)
  }
}
